import { format } from 'date-fns'
import formatDistanceToNow from 'date-fns/formatDistanceToNow'
import React from 'react'
import classNames from 'classnames'
import type { ClassValue } from 'classnames/types'
import { Tooltip } from './tooltip'
interface RelativeTimestampProps {
    date: Date | number | string
    className?: ClassValue
}

const toDate = (value: Date | number | string): Date | null => {
    if (value instanceof Date) {
        return Number.isFinite(value.getTime()) ? value : null
    }

    if (typeof value === 'string' && !/^\d+$/.test(value)) {
        const date = new Date(value)
        return Number.isFinite(date.getTime()) ? date : null
    }

    const timestamp = Number(value)
    if (!Number.isSafeInteger(timestamp)) {
        return null
    }

    const date = new Date(timestamp < 10000000000 ? timestamp * 1000 : timestamp)
    return Number.isFinite(date.getTime()) ? date : null
}

export const RelativeTimestamp = ({ date, className }: RelativeTimestampProps) => {
    const parsedDate = toDate(date)
    if (!parsedDate) {
        return null
    }

    return (
        <Tooltip content={format(parsedDate, 'M/d/yy H:mm a')} className={classNames(className)}>
            {formatDistanceToNow(parsedDate, { addSuffix: true })}
        </Tooltip>
    )
}
